import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Home from "./user/home";
import Signup from "./user/Signup";
import Signin from "./user/Signin";
import Pages from "./user/Pages";
import PrivateRoute from "./auth/helper/PrivateRoutes";
const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/signup" exact component={Signup} />
        <Route path="/signin" exact component={Signin} />
        <PrivateRoute path="/pages" exact component={Pages} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
